export default "__VITE_ASSET__83fe3b1a__"